export class CategoryAlreadyExistsMessage {
    public name: string;
    
    constructor(name: string)
    {
        this.name = name;
    }
}